/* eslint-disable class-methods-use-this */
/* eslint-disable max-len */
import { advancedSearch, advancedSecSort } from 'helpers/utils';
import ISearcher from 'ISearcher';
import ISorter from 'ISorter';
import AccessResource from './resource';

export class AccessSearcher implements ISorter<AccessResource, keyof AccessResource>, ISearcher<AccessResource, keyof AccessResource> {
  search = (
    item: AccessResource,
    value: any,
    type: keyof AccessResource,
  ) => advancedSearch(item, value, type, false);

  sort = (
    a: AccessResource,
    b: AccessResource,
    primary: keyof AccessResource,
    secondary?: keyof AccessResource,
  ) => advancedSecSort(a, b, primary, secondary);
}

export default AccessSearcher;
